
function pad(number: number): number | string {
  if (number < 10) {
    return '0' + number;
  }
  return number;
}

function toISODateString(d: Date) {
  return d.getFullYear() +
    '-' + pad(d.getMonth() + 1) +
    '-' + pad(d.getDate()) +
    'T00:00:00';
    ;
}
function SafeConvertDateToString(d: Date, chain: Function): string {
  //if (d.getHours() === 0 && d.getMinutes() === 0 && d.getSeconds() === 0 && d.getMilliseconds() === 0) // Apenas uma data, sem hora
    return toISODateString(d);
  //else
  //  if (chain.toString().includes('toISOString')) {
  //    let dateString = chain.apply(d);
  //    if (dateString.endsWith('Z')) {
  //      //let result = dateString.slice(0, dateString.indexOf('T'));
  //      let result = dateString.slice(0, -1);
  //      return result;

  //      //let cleanDate = new Date(dateString);
  //      //cleanDate.setHours(0);
  //      //cleanDate.setMinutes(0);
  //      //cleanDate.setSeconds(0);
  //      //return SafeConvertDateToString(cleanDate, Date.prototype.toJSON);
  //    }
  //  } else { 
  //    return chain.apply(d);
  //  }
}

export function useCorrectedDateJSONSerializer() {
  const __savedToJSON = Date.prototype.toJSON;
  const __savedToISOString = Date.prototype.toISOString;

  Date.prototype.toJSON = function () {
    return SafeConvertDateToString(this, __savedToJSON);
  }
  Date.prototype.toISOString = function () {
    return SafeConvertDateToString(this, __savedToISOString);
  }
}
